// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import './assets/UE/ueditor.config.js'
import './assets/UE/ueditor.all.min.js'
import './assets/UE/lang/zh-cn/zh-cn.js'
import './assets/UE/ueditor.parse.min.js'

import '@/assets/style/base.scss'

// 第一个是videoJs的样式，后一个是vue-video-player的样式，因为考虑到我其他业务组件可能也会用到视频播放，所以就放在了main.js内
// require('videojs-contrib-hls/dist/videojs-contrib-hls');
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer);

// import VideoPlayer from "vue-video-player";
// require("video.js/dist/video-js.css");
// import 'video.js'
// import 'videojs-flash'
// import hls from "videojs-contrib-hls";
// Vue.use(hls)
// Vue.use(VideoPlayer)


Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 6000)
      }
    })
  }
})

// 兼容 IE9，没有 console 对象
import console from 'shim-console'
console.init()

// 设置请求默认路径 设置文件在 ../config dev.env.js + prod.env.js
// axios.defaults.baseURL = process.env.API_ROOT
axios.defaults.baseURL = process.env.HOST
axios.defaults.headers['xx-platform'] = 'pc'

Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.prototype.$axios = axios

axios.interceptors.request.use(function(config) {
  const info = JSON.parse(localStorage.getItem('user'))
  let token = info ? info.token : undefined
  if (config.method === 'post') {
    let data = qs.parse(config.data)
    config.data = qs.stringify({
      token: token,
      ...data
    })
  } else if (config.method === 'get') {
    config.params = {
      token: token,
      ...config.params
    }
  }
  return config
}, function(error) {
  return Promise.reject(error)
})


axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

router.afterEach(async (to, from) => {
  let user = localStorage.getItem('user')

  if (to.meta && to.meta.unauth) {
    if (user) {
      localStorage.removeItem('user')
      store.commit('setValue', { token: '', uname: '', isCeping: false })
    }
  } else {
    if (user) {
      user = JSON.parse(user)
      if (store.state.token === '') {
        store.commit('setValue', user)
      }

      // 若未通过测评，则不能跳转到其他页
      // if (to.name !== 'ceping' && user.role === 'user' && !store.state.isCeping) {
      //   const { isCeping } = await syncCeping()
      //   if (!isCeping) {
      //     Message.info({
      //       message: '必须先通过测评，才能访问其他页面'
      //     })
      //     router.push('/user/ceping')
      //     return
      //   }
      // }

      // 跳转到角色主页
      if (to.params.role !== user.role) {
        to.params.role = user.role
        router.push(to.path.replace(/^\/[^\/]+/,`/${user.role}`))
      }
    } else {
      if (to.name === 'Index') {
        return false
      }
      router.push('/login/main')
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js